module.exports = __webpack_public_path__ + "static/polarpumpen-env1-min-94ceea5f5725c3b96592e9a7eda244a6.jpg";